import React, { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../AppContextProvider";
import { findChildrenOfNodeById } from "../utils/graph/graphmodifier";
import { getMetadataJwt } from "../utils/dwclient/dwmetadata";
import { DwMpcWalletBackendProviderContext } from "../mpcwalletprovider/DwMpcWalletBackendProvider";
import { WalletProviderContext } from "../walletprovider/WalletProvider";
import { loadJwt } from "../utils/dwclient/localstorage/jwtStorage";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Share from "yet-another-react-lightbox/plugins/share";
import Download from "yet-another-react-lightbox/plugins/download";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
export default function ContextInfoComponent(props) {
  const context = useContext(AppContext);
  const { selectedAccount, selectedWallet } = useContext(WalletProviderContext);
  const [isDark, setIsDark] = useState(true);
  const [isVisibilityDiv, setIsVisibilityDiv] = useState(true);
  const [pfadArray, setPfadArray] = useState([]);
  const [open, setOpen] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [foto, setFoto] = useState([]);
  const [metaData, setMetaData] = useState();
  const [timeLineItems, setTimeLineItems] = useState();
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  useEffect(() => {
    if (props.nodes && props.network) {
      var parentsPfadArray = [];
      // var categoryNumber = props.nodeDatas.group.charAt(0);
      var level = props.selectedNode.level;
      var id = props.selectedNode.id;
      if (level > 1) {
        while (level > 1) {
          var actuelleNode = props.nodes.filter((k) => k.id === props.network.getConnectedNodes(id, "from")[0])[0];
          var text = actuelleNode.label;
          id = actuelleNode.id;
          if (text) {
            let s = text.toString();
            let capitalizedvalue2 = s[0].toUpperCase() + s.slice(1);
            let finishText = capitalizedvalue2.match(/[A-Z][a-z]+|[0-9]+/g)
              ? capitalizedvalue2

                  .match(/[A-Z][a-z]+|[0-9]+/g)
                  .join(" ")
                  .replace("_", " ")
              : s.replace("_", " ");
            parentsPfadArray.push(finishText);
          }
          level = level - 1;
        }
      }
      setPfadArray(parentsPfadArray.reverse());
    }
  }, [props.selectedNode]);

  const setOpenLightbox = (foto) => {
    let array = [];
    array.push(foto);
    setFoto(array);
    setOpen(true);
  };

  const readMetaDatas = async (node) => {
    if (node.metadataType !== undefined) {
      try {
        const authToken = await loadJwt();
        const result = await getMetadataJwt(selectedWallet?.provider, authToken, node.storagePath);

        let paramObject = { selectedNode: props.selectedNode, metaArray: result };
        context.openModal("metafile", "", paramObject);
        setMetaData(result);
        props.handleWindowInfoSizeChange();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const readSerieMetaDatas = async (node) => {
    if (node.metadataType !== undefined) {
      try {
        const authToken = await loadJwt();
        const result = await getMetadataJwt(selectedWallet?.provider, authToken, node.storagePath);

        let paramObject = { selectedNode: props.selectedNode, metaArray: result };
        context.openModal("timelinemodal", "", paramObject);
        setMetaData(result);
        props.handleWindowInfoSizeChange();
      } catch (error) {
        console.log(error);
      }
    }
  };

  function hasPreviewImage(fileMimeType) {
    if (fileMimeType === undefined || fileMimeType === "") {
      return false;
    }
    if (fileMimeType.startsWith("image/")) {
      return true;
    }
    if (fileMimeType === "application/zip") {
      return true;
    }
    if (fileMimeType === "application/pdf") {
      return true;
    }
    return false;
  }

  const memory = {};
  let imagePreviewCorrection = 0;
  if (hasPreviewImage(props.selectedNode.properties?.fileMimeType)) {
    imagePreviewCorrection = 200;
  }

  const localMenuSize = (props.contextMenu.menuSize / 2) * (1 - 0.41) * props.contextMenu.network.getScale();
  const canvasHeight = props.contextMenu.canvasHeight ?? 700;
  const wert_2 = canvasHeight - 200 - props.contextMenu.y - localMenuSize - imagePreviewCorrection;

  return (
    <>
      {props.contextMenu && (
        <div
          className="context-info-new"
          style={{
            top: wert_2 > 0 ? props.contextMenu.y + localMenuSize : "unset",
            bottom: wert_2 > 0 ? "unset" : canvasHeight - props.contextMenu.y + localMenuSize,
            left: props.contextMenu.x - (224 + localMenuSize),
          }}
        >
          {props.isNodeSelect && props.selectedNode && (
            <div className="folder-info-div">
              <div className="title-div">
                <span className="title-text">{props.selectedNode.label}</span>
              </div>
              {props.selectedNode.properties &&
                Object.entries(props.selectedNode.properties).map(([k, n], l) => {
                  {
                    /*
                  if (k === "fileMimeType" && n === "image/png") {
                    memory.mimeType = n;
                  }
                    */
                  }
                  return (
                    <div className="div-2" key={l} style={{ cursor: "pointer" }}>
                      {n !== undefined && (
                        <>
                          <span className="description-text">
                            {k.toString().match(/[A-Z][a-z]+|[0-9]+/g) !== null
                              ? k
                                  .toString()
                                  .match(/[A-Z][a-z]+|[0-9]+/g)
                                  .join(" ") +
                                ": " +
                                n.toString().replace("_", " ")
                              : k + ": " + n.toString().replace("_", " ")}
                          </span>

                          {/*k === "fileStorageId" && memory.mimeType?.toString().startsWith("image") ? (
                            <div className="img-div">
                              <img
                                src={n}
                                alt=""
                                onClick={() => setOpenLightbox(n)}
                                style={{ cursor: "pointer" }}
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                              />
                              {isHover && props.file === undefined && (
                                <div
                                  className="svg-icon"
                                  onMouseEnter={() => setIsHover(true)}
                                  onClick={() => setOpenLightbox(n)}
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.56685 12.3168L4.63361 16.2501H6.8751C7.04773 16.2501 7.20398 16.3201 7.31698 16.4331C7.43 16.5461 7.5001 16.7023 7.5 16.8751C7.5 17.2202 7.22023 17.5 6.8751 17.5H3.12486C3.12411 17.5 3.12348 17.4996 3.12286 17.4996C3.04211 17.4993 2.96186 17.4831 2.88625 17.4517C2.73323 17.3885 2.61148 17.2667 2.54823 17.1137C2.51686 17.038 2.50061 16.9578 2.50036 16.8771C2.50036 16.8765 2.5 16.8758 2.5 16.8751V13.1248C2.5 12.7796 2.77973 12.5 3.12486 12.5C3.47011 12.5 3.74986 12.7796 3.74986 13.1248L3.74973 15.3665L7.6831 11.4331C7.92723 11.189 8.32273 11.189 8.56685 11.4331C8.81098 11.6772 8.81098 12.0727 8.56685 12.3168ZM11.4331 12.3168L15.3663 16.2501H13.1248C12.9522 16.2501 12.796 16.3201 12.683 16.4331C12.57 16.5461 12.4998 16.7023 12.5 16.8751C12.5 17.2202 12.7797 17.5 13.1248 17.5H16.8751C16.8758 17.5 16.8765 17.4996 16.8771 17.4996C16.9578 17.4993 17.0381 17.4831 17.1137 17.4517C17.2667 17.3885 17.3885 17.2667 17.4517 17.1137C17.4831 17.038 17.4993 16.9578 17.4996 16.8771C17.4996 16.8765 17.5 16.8758 17.5 16.8751V13.1248C17.5 12.7796 17.2202 12.5 16.8751 12.5C16.5298 12.5 16.2501 12.7796 16.2501 13.1248L16.2502 15.3665L12.3168 11.4331C12.0727 11.189 11.6772 11.189 11.4331 11.4331C11.189 11.6772 11.189 12.0727 11.4331 12.3168ZM8.56685 7.68312L4.63361 3.74987H6.8751C7.04773 3.74987 7.20398 3.67987 7.31698 3.56687C7.43 3.45387 7.5001 3.29762 7.5 3.12487C7.5 2.77975 7.22023 2.5 6.8751 2.5H3.12486C3.12411 2.5 3.12348 2.50037 3.12286 2.50037C3.04211 2.50062 2.96186 2.51687 2.88625 2.54825C2.73323 2.6115 2.61148 2.73325 2.54823 2.88625C2.51686 2.962 2.50061 3.04213 2.50036 3.12288C2.50036 3.1235 2.5 3.12412 2.5 3.12487V6.87512C2.5 7.22038 2.77973 7.5 3.12486 7.5C3.47011 7.5 3.74986 7.22038 3.74986 6.87512L3.74973 4.6335L7.6831 8.56688C7.92723 8.811 8.32273 8.811 8.56685 8.56688C8.81098 8.32275 8.81098 7.92725 8.56685 7.68312ZM11.4331 8.56688C11.6772 8.811 12.0727 8.811 12.3168 8.56688L16.2502 4.6335L16.2501 6.87512C16.2501 7.22038 16.5298 7.5 16.8751 7.5C17.2202 7.5 17.5 7.22038 17.5 6.87512V3.12487C17.5 3.12412 17.4996 3.1235 17.4996 3.12288C17.4993 3.04213 17.4831 2.962 17.4517 2.88625C17.3885 2.73325 17.2667 2.6115 17.1137 2.54825C17.0381 2.51687 16.9578 2.50062 16.8771 2.50037C16.8765 2.50037 16.8758 2.5 16.8751 2.5H13.1248C12.7797 2.5 12.5 2.77975 12.5 3.12487C12.4998 3.29762 12.57 3.45387 12.683 3.56687C12.796 3.67987 12.9522 3.74987 13.1248 3.74987H15.3663L11.4331 7.68312C11.189 7.92725 11.189 8.32275 11.4331 8.56688Z"
                                      fill="white"
                                    />
                                  </svg>
                                  <svg
                                    width="64"
                                    height="64"
                                    viewBox="0 0 64 64"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M16 24V12H40V20H48V24H52V18.8008C52 18.2695 51.7891 17.7617 51.4141 17.3867L42.6133 8.58594C42.2383 8.21094 41.7305 8 41.1992 8H14C12.8945 8 12 8.89453 12 10V24H16ZM48 48V52H16V48H12V54C12 55.1055 12.8945 56 14 56H50C51.1055 56 52 55.1055 52 54V48H48Z"
                                      fill="#19778A"
                                    />
                                    <path
                                      d="M12 44V28H18.7277C19.8281 28 20.7613 28.2043 21.5274 28.6128C22.2935 29.0213 22.8716 29.6038 23.2616 30.3603C23.6655 31.1168 23.8675 32.0322 23.8675 33.1064C23.8675 34.1806 23.6655 35.1035 23.2616 35.8752C22.8716 36.6317 22.2935 37.2142 21.5274 37.6227C20.7613 38.0312 19.8281 38.2355 18.7277 38.2355H15.2385V44H12ZM15.2385 35.5121H18.1845C19.0202 35.5121 19.654 35.3078 20.0858 34.8993C20.5315 34.4908 20.7544 33.8931 20.7544 33.1064C20.7544 32.3196 20.5315 31.7296 20.0858 31.3362C19.654 30.9428 19.0202 30.7461 18.1845 30.7461H15.2385V35.5121Z"
                                      fill="#19778A"
                                    />
                                    <path
                                      d="M25.8745 44V28H31.6411C33.3126 28 34.7334 28.3177 35.9034 28.9532C37.0874 29.5735 37.9858 30.4813 38.5987 31.6766C39.2255 32.8567 39.5389 34.2941 39.5389 35.9887C39.5389 37.6832 39.2255 39.1281 38.5987 40.3234C37.9858 41.5187 37.0874 42.434 35.9034 43.0695C34.7334 43.6898 33.3126 44 31.6411 44H25.8745ZM29.113 41.1177H31.4531C33.0271 41.1177 34.2041 40.6941 34.9841 39.8468C35.7641 38.9995 36.1541 37.7135 36.1541 35.9887C36.1541 34.2638 35.7571 32.9853 34.9632 32.1532C34.1832 31.3059 33.0131 30.8823 31.4531 30.8823H29.113V41.1177Z"
                                      fill="#19778A"
                                    />
                                    <path
                                      d="M42.0547 44V28H52V30.7461H45.2932V34.6496H51.5403V37.3957H45.2932V44H42.0547Z"
                                      fill="#19778A"
                                    />
                                  </svg>
                                </div>
                              )}
                            </div>
                          ) : (
                            <span className="description-text">
                              {k.toString().match(/[A-Z][a-z]+|[0-9]+/g) !== null
                                ? k
                                    .toString()
                                    .match(/[A-Z][a-z]+|[0-9]+/g)
                                    .join(" ") +
                                  ": " +
                                  n.toString().replace("_", " ")
                                : k + ": " + n.toString().replace("_", " ")}
                            </span>
                          )*/}
                        </>
                      )}
                    </div>
                  );
                })}
              {pfadArray.length > 0 && (
                <div className="pfad-div">
                  <span className="pfad-text">Path: </span>
                  {pfadArray.map((k, n) => {
                    return (
                      <span className="pfad-text" key={n}>
                        {k + "/"}
                      </span>
                    );
                  })}
                </div>
              )}
            </div>
          )}
          {props.file && props.isNodeSelect && (
            <div className="folder-info-div">
              {props.fileType === "image/jpg" ||
              props.fileType === "image/jpeg" ||
              props.fileType === "image/png" ||
              props.fileName.includes("JPG") ? (
                <div className="img-div">
                  <img src={props.file} alt="" style={{ borderRadius: "6px" }} />

                  <div className="svg-icon" onClick={() => setOpenLightbox(props.file)}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.85348 9.85348L3.70688 13.0001H5.50008C5.63818 13.0001 5.76318 13.0561 5.85358 13.1465C5.944 13.2369 6.00008 13.3619 6 13.5001C6 13.7762 5.77618 14 5.50008 14H2.49988C2.49928 14 2.49878 13.9997 2.49828 13.9997C2.43368 13.9995 2.36948 13.9865 2.309 13.9614C2.18658 13.9108 2.08918 13.8134 2.03858 13.691C2.01348 13.6304 2.00048 13.5663 2.00028 13.5017C2.00028 13.5012 2 13.5007 2 13.5001V10.4999C2 10.2237 2.22378 9.99998 2.49988 9.99998C2.77608 9.99998 2.99988 10.2237 2.99988 10.4999L2.99978 12.2932L6.14648 9.14647C6.34178 8.95117 6.65818 8.95117 6.85348 9.14647C7.04878 9.34177 7.04878 9.65818 6.85348 9.85348ZM9.14647 9.85348L12.2931 13.0001H10.4999C10.3618 13.0001 10.2368 13.0561 10.1464 13.1465C10.056 13.2369 9.99987 13.3619 9.99999 13.5001C9.99999 13.7762 10.2238 14 10.4999 14H13.5001C13.5007 14 13.5012 13.9997 13.5017 13.9997C13.5663 13.9995 13.6305 13.9865 13.691 13.9614C13.8134 13.9108 13.9108 13.8134 13.9614 13.691C13.9865 13.6304 13.9995 13.5663 13.9997 13.5017C13.9997 13.5012 14 13.5007 14 13.5001V10.4999C14 10.2237 13.7762 9.99998 13.5001 9.99998C13.2239 9.99998 13.0001 10.2237 13.0001 10.4999L13.0002 12.2932L9.85347 9.14647C9.65817 8.95117 9.34177 8.95117 9.14647 9.14647C8.95117 9.34177 8.95117 9.65818 9.14647 9.85348ZM6.85348 6.1465L3.70688 2.9999H5.50008C5.63818 2.9999 5.76318 2.9439 5.85358 2.8535C5.944 2.7631 6.00008 2.6381 6 2.4999C6 2.2238 5.77618 2 5.50008 2H2.49988C2.49928 2 2.49878 2.0003 2.49828 2.0003C2.43368 2.0005 2.36948 2.0135 2.309 2.0386C2.18658 2.0892 2.08918 2.1866 2.03858 2.309C2.01348 2.3696 2.00048 2.4337 2.00028 2.4983C2.00028 2.4988 2 2.4993 2 2.4999V5.5001C2 5.7763 2.22378 6 2.49988 6C2.77608 6 2.99988 5.7763 2.99988 5.5001L2.99978 3.7068L6.14648 6.8535C6.34178 7.0488 6.65818 7.0488 6.85348 6.8535C7.04878 6.6582 7.04878 6.3418 6.85348 6.1465ZM9.14647 6.8535C9.34177 7.0488 9.65817 7.0488 9.85347 6.8535L13.0002 3.7068L13.0001 5.5001C13.0001 5.7763 13.2239 6 13.5001 6C13.7762 6 14 5.7763 14 5.5001V2.4999C14 2.4993 13.9997 2.4988 13.9997 2.4983C13.9995 2.4337 13.9865 2.3696 13.9614 2.309C13.9108 2.1866 13.8134 2.0892 13.691 2.0386C13.6305 2.0135 13.5663 2.0005 13.5017 2.0003C13.5012 2.0003 13.5007 2 13.5001 2H10.4999C10.2238 2 9.99999 2.2238 9.99999 2.4999C9.99988 2.6381 10.056 2.7631 10.1464 2.8535C10.2368 2.9439 10.3618 2.9999 10.4999 2.9999H12.2931L9.14647 6.1465C8.95117 6.3418 8.95117 6.6582 9.14647 6.8535Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    className="svg-icon2"
                    onClick={() => {
                      if (props.isDownloadButton) {
                        props.downloadFile(props.selectedNode);
                      }
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10.3535 7.85352L8.35349 9.85352C8.30708 9.89996 8.25197 9.9368 8.19131 9.96193C8.13066 9.98706 8.06565 10 7.99999 10C7.93433 10 7.86932 9.98706 7.80867 9.96193C7.74801 9.9368 7.6929 9.89996 7.64649 9.85352L5.64649 7.85352C5.55395 7.75951 5.50232 7.63274 5.50284 7.50084C5.50336 7.36893 5.55599 7.24257 5.64926 7.14929C5.74254 7.05602 5.8689 7.00339 6.00081 7.00287C6.13271 7.00235 6.25948 7.05398 6.35349 7.14652L7.5 8.293V3.5C7.5 3.36739 7.55268 3.24021 7.64645 3.14645C7.74021 3.05268 7.86739 3 8 3C8.13261 3 8.25979 3.05268 8.35355 3.14645C8.44732 3.24021 8.5 3.36739 8.5 3.5V8.293L9.64649 7.14648C9.7405 7.05394 9.86726 7.00231 9.99917 7.00283C10.1311 7.00335 10.2574 7.05598 10.3507 7.14925C10.444 7.24253 10.4966 7.36889 10.4971 7.5008C10.4977 7.6327 10.446 7.75951 10.3535 7.85352ZM14 13.5C14 13.4343 13.9871 13.3693 13.962 13.3086C13.9369 13.2479 13.9001 13.1928 13.8536 13.1464C13.8072 13.0999 13.7521 13.0631 13.6914 13.038C13.6307 13.0129 13.5657 13 13.5 13H2.5C2.36739 13 2.24021 13.0527 2.14645 13.1464C2.05268 13.2402 2 13.3674 2 13.5C2 13.6326 2.05268 13.7598 2.14645 13.8536C2.24021 13.9473 2.36739 14 2.5 14H13.5C13.5657 14 13.6307 13.9871 13.6914 13.962C13.7521 13.9369 13.8072 13.9001 13.8536 13.8536C13.9001 13.8072 13.9369 13.7521 13.962 13.6914C13.9871 13.6307 14 13.5657 14 13.5Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              ) : (
                <div className="file-default-icon">
                  <div className="file-div">
                    {props.fileType === "application/zip" && (
                      <>
                        <div
                          className="svg-icon"
                          onClick={() => {
                            if (props.isDownloadButton) {
                              props.downloadZip(
                                props.selectedNode.properties.fileStorageId,
                                props.selectedNode.properties.fileName,
                              );
                            }
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.3535 7.85352L8.35349 9.85352C8.30708 9.89996 8.25197 9.9368 8.19131 9.96193C8.13066 9.98706 8.06565 10 7.99999 10C7.93433 10 7.86932 9.98706 7.80867 9.96193C7.74801 9.9368 7.6929 9.89996 7.64649 9.85352L5.64649 7.85352C5.55395 7.75951 5.50232 7.63274 5.50284 7.50084C5.50336 7.36893 5.55599 7.24257 5.64926 7.14929C5.74254 7.05602 5.8689 7.00339 6.00081 7.00287C6.13271 7.00235 6.25948 7.05398 6.35349 7.14652L7.5 8.293V3.5C7.5 3.36739 7.55268 3.24021 7.64645 3.14645C7.74021 3.05268 7.86739 3 8 3C8.13261 3 8.25979 3.05268 8.35355 3.14645C8.44732 3.24021 8.5 3.36739 8.5 3.5V8.293L9.64649 7.14648C9.7405 7.05394 9.86726 7.00231 9.99917 7.00283C10.1311 7.00335 10.2574 7.05598 10.3507 7.14925C10.444 7.24253 10.4966 7.36889 10.4971 7.5008C10.4977 7.6327 10.446 7.75951 10.3535 7.85352ZM14 13.5C14 13.4343 13.9871 13.3693 13.962 13.3086C13.9369 13.2479 13.9001 13.1928 13.8536 13.1464C13.8072 13.0999 13.7521 13.0631 13.6914 13.038C13.6307 13.0129 13.5657 13 13.5 13H2.5C2.36739 13 2.24021 13.0527 2.14645 13.1464C2.05268 13.2402 2 13.3674 2 13.5C2 13.6326 2.05268 13.7598 2.14645 13.8536C2.24021 13.9473 2.36739 14 2.5 14H13.5C13.5657 14 13.6307 13.9871 13.6914 13.962C13.7521 13.9369 13.8072 13.9001 13.8536 13.8536C13.9001 13.8072 13.9369 13.7521 13.962 13.6914C13.9871 13.6307 14 13.5657 14 13.5Z"
                              fill="white"
                            />
                          </svg>
                        </div>

                        <div>
                          <svg
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16 24V12H40V20H48V24H52V18.8008C52 18.2695 51.7891 17.7617 51.4141 17.3867L42.6133 8.58594C42.2383 8.21094 41.7305 8 41.1992 8H14C12.8945 8 12 8.89453 12 10V24H16ZM48 48V52H16V48H12V54C12 55.1055 12.8945 56 14 56H50C51.1055 56 52 55.1055 52 54V48H48Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path
                              d="M12 44V41.4128L21.0838 29.861V30.9277H12V28H24.5108V30.5872L15.4035 42.1163V41.0723H24.8628V44H12Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path d="M29.375 44V28H33.0133V44H29.375Z" fill="var(--text-accent-tertiary)" />
                            <path
                              d="M38.6677 44V28H46.2258C47.462 28 48.5104 28.2043 49.3711 28.6128C50.2318 29.0213 50.8812 29.6038 51.3193 30.3603C51.7731 31.1168 52 32.0322 52 33.1064C52 34.1806 51.7731 35.1035 51.3193 35.8752C50.8812 36.6317 50.2318 37.2142 49.3711 37.6227C48.5104 38.0312 47.462 38.2355 46.2258 38.2355H42.3059V44H38.6677ZM42.3059 35.5121H45.6155C46.5544 35.5121 47.2664 35.3078 47.7515 34.8993C48.2523 34.4908 48.5026 33.8931 48.5026 33.1064C48.5026 32.3196 48.2523 31.7296 47.7515 31.3362C47.2664 30.9428 46.5544 30.7461 45.6155 30.7461H42.3059V35.5121Z"
                              fill="var(--text-accent-tertiary)"
                            />
                          </svg>
                        </div>
                      </>
                    )}
                    {props.fileType === "application/pdf" && (
                      <>
                        <div
                          className="svg-icon"
                          onClick={() => {
                            const imageUrl = URL.createObjectURL(props.blobFile);
                            window.open(imageUrl);
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.85348 9.85348L3.70688 13.0001H5.50008C5.63818 13.0001 5.76318 13.0561 5.85358 13.1465C5.944 13.2369 6.00008 13.3619 6 13.5001C6 13.7762 5.77618 14 5.50008 14H2.49988C2.49928 14 2.49878 13.9997 2.49828 13.9997C2.43368 13.9995 2.36948 13.9865 2.309 13.9614C2.18658 13.9108 2.08918 13.8134 2.03858 13.691C2.01348 13.6304 2.00048 13.5663 2.00028 13.5017C2.00028 13.5012 2 13.5007 2 13.5001V10.4999C2 10.2237 2.22378 9.99998 2.49988 9.99998C2.77608 9.99998 2.99988 10.2237 2.99988 10.4999L2.99978 12.2932L6.14648 9.14647C6.34178 8.95117 6.65818 8.95117 6.85348 9.14647C7.04878 9.34177 7.04878 9.65818 6.85348 9.85348ZM9.14647 9.85348L12.2931 13.0001H10.4999C10.3618 13.0001 10.2368 13.0561 10.1464 13.1465C10.056 13.2369 9.99987 13.3619 9.99999 13.5001C9.99999 13.7762 10.2238 14 10.4999 14H13.5001C13.5007 14 13.5012 13.9997 13.5017 13.9997C13.5663 13.9995 13.6305 13.9865 13.691 13.9614C13.8134 13.9108 13.9108 13.8134 13.9614 13.691C13.9865 13.6304 13.9995 13.5663 13.9997 13.5017C13.9997 13.5012 14 13.5007 14 13.5001V10.4999C14 10.2237 13.7762 9.99998 13.5001 9.99998C13.2239 9.99998 13.0001 10.2237 13.0001 10.4999L13.0002 12.2932L9.85347 9.14647C9.65817 8.95117 9.34177 8.95117 9.14647 9.14647C8.95117 9.34177 8.95117 9.65818 9.14647 9.85348ZM6.85348 6.1465L3.70688 2.9999H5.50008C5.63818 2.9999 5.76318 2.9439 5.85358 2.8535C5.944 2.7631 6.00008 2.6381 6 2.4999C6 2.2238 5.77618 2 5.50008 2H2.49988C2.49928 2 2.49878 2.0003 2.49828 2.0003C2.43368 2.0005 2.36948 2.0135 2.309 2.0386C2.18658 2.0892 2.08918 2.1866 2.03858 2.309C2.01348 2.3696 2.00048 2.4337 2.00028 2.4983C2.00028 2.4988 2 2.4993 2 2.4999V5.5001C2 5.7763 2.22378 6 2.49988 6C2.77608 6 2.99988 5.7763 2.99988 5.5001L2.99978 3.7068L6.14648 6.8535C6.34178 7.0488 6.65818 7.0488 6.85348 6.8535C7.04878 6.6582 7.04878 6.3418 6.85348 6.1465ZM9.14647 6.8535C9.34177 7.0488 9.65817 7.0488 9.85347 6.8535L13.0002 3.7068L13.0001 5.5001C13.0001 5.7763 13.2239 6 13.5001 6C13.7762 6 14 5.7763 14 5.5001V2.4999C14 2.4993 13.9997 2.4988 13.9997 2.4983C13.9995 2.4337 13.9865 2.3696 13.9614 2.309C13.9108 2.1866 13.8134 2.0892 13.691 2.0386C13.6305 2.0135 13.5663 2.0005 13.5017 2.0003C13.5012 2.0003 13.5007 2 13.5001 2H10.4999C10.2238 2 9.99999 2.2238 9.99999 2.4999C9.99988 2.6381 10.056 2.7631 10.1464 2.8535C10.2368 2.9439 10.3618 2.9999 10.4999 2.9999H12.2931L9.14647 6.1465C8.95117 6.3418 8.95117 6.6582 9.14647 6.8535Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          className="svg-icon2"
                          onMouseEnter={() => setIsHover(true)}
                          onClick={() => {
                            if (props.isDownloadButton) {
                              props.downloadFile(props.selectedNode);
                            }
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.3535 7.85352L8.35349 9.85352C8.30708 9.89996 8.25197 9.9368 8.19131 9.96193C8.13066 9.98706 8.06565 10 7.99999 10C7.93433 10 7.86932 9.98706 7.80867 9.96193C7.74801 9.9368 7.6929 9.89996 7.64649 9.85352L5.64649 7.85352C5.55395 7.75951 5.50232 7.63274 5.50284 7.50084C5.50336 7.36893 5.55599 7.24257 5.64926 7.14929C5.74254 7.05602 5.8689 7.00339 6.00081 7.00287C6.13271 7.00235 6.25948 7.05398 6.35349 7.14652L7.5 8.293V3.5C7.5 3.36739 7.55268 3.24021 7.64645 3.14645C7.74021 3.05268 7.86739 3 8 3C8.13261 3 8.25979 3.05268 8.35355 3.14645C8.44732 3.24021 8.5 3.36739 8.5 3.5V8.293L9.64649 7.14648C9.7405 7.05394 9.86726 7.00231 9.99917 7.00283C10.1311 7.00335 10.2574 7.05598 10.3507 7.14925C10.444 7.24253 10.4966 7.36889 10.4971 7.5008C10.4977 7.6327 10.446 7.75951 10.3535 7.85352ZM14 13.5C14 13.4343 13.9871 13.3693 13.962 13.3086C13.9369 13.2479 13.9001 13.1928 13.8536 13.1464C13.8072 13.0999 13.7521 13.0631 13.6914 13.038C13.6307 13.0129 13.5657 13 13.5 13H2.5C2.36739 13 2.24021 13.0527 2.14645 13.1464C2.05268 13.2402 2 13.3674 2 13.5C2 13.6326 2.05268 13.7598 2.14645 13.8536C2.24021 13.9473 2.36739 14 2.5 14H13.5C13.5657 14 13.6307 13.9871 13.6914 13.962C13.7521 13.9369 13.8072 13.9001 13.8536 13.8536C13.9001 13.8072 13.9369 13.7521 13.962 13.6914C13.9871 13.6307 14 13.5657 14 13.5Z"
                              fill="white"
                            />
                          </svg>
                        </div>

                        <div>
                          <svg
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16 24V12H40V20H48V24H52V18.8008C52 18.2695 51.7891 17.7617 51.4141 17.3867L42.6133 8.58594C42.2383 8.21094 41.7305 8 41.1992 8H14C12.8945 8 12 8.89453 12 10V24H16ZM48 48V52H16V48H12V54C12 55.1055 12.8945 56 14 56H50C51.1055 56 52 55.1055 52 54V48H48Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path
                              d="M12 44V28H18.7277C19.8281 28 20.7613 28.2043 21.5274 28.6128C22.2935 29.0213 22.8716 29.6038 23.2616 30.3603C23.6655 31.1168 23.8675 32.0322 23.8675 33.1064C23.8675 34.1806 23.6655 35.1035 23.2616 35.8752C22.8716 36.6317 22.2935 37.2142 21.5274 37.6227C20.7613 38.0312 19.8281 38.2355 18.7277 38.2355H15.2385V44H12ZM15.2385 35.5121H18.1845C19.0202 35.5121 19.654 35.3078 20.0858 34.8993C20.5315 34.4908 20.7544 33.8931 20.7544 33.1064C20.7544 32.3196 20.5315 31.7296 20.0858 31.3362C19.654 30.9428 19.0202 30.7461 18.1845 30.7461H15.2385V35.5121Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path
                              d="M25.8745 44V28H31.6411C33.3126 28 34.7334 28.3177 35.9034 28.9532C37.0874 29.5735 37.9858 30.4813 38.5987 31.6766C39.2255 32.8567 39.5389 34.2941 39.5389 35.9887C39.5389 37.6832 39.2255 39.1281 38.5987 40.3234C37.9858 41.5187 37.0874 42.434 35.9034 43.0695C34.7334 43.6898 33.3126 44 31.6411 44H25.8745ZM29.113 41.1177H31.4531C33.0271 41.1177 34.2041 40.6941 34.9841 39.8468C35.7641 38.9995 36.1541 37.7135 36.1541 35.9887C36.1541 34.2638 35.7571 32.9853 34.9632 32.1532C34.1832 31.3059 33.0131 30.8823 31.4531 30.8823H29.113V41.1177Z"
                              fill="var(--text-accent-tertiary)"
                            />
                            <path
                              d="M42.0547 44V28H52V30.7461H45.2932V34.6496H51.5403V37.3957H45.2932V44H42.0547Z"
                              fill="var(--text-accent-tertiary)"
                            />
                          </svg>
                        </div>
                      </>
                    )}
                    {props.fileType !== "application/pdf" && props.fileType !== "application/zip" && (
                      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M51.4141 17.3867L42.6133 8.58592C42.2383 8.21092 41.7305 8 41.1992 8H14C12.8945 8 12 8.89452 12 10V54C12 55.1055 12.8945 56 14 56H50C51.1055 56 52 55.1055 52 54V18.8008C52 18.2696 51.7891 17.7617 51.4141 17.3867ZM16 52V12H40V20H48V52H16Z"
                          fill="var(--text-accent-tertiary)"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {props.selectedNode.metadataType && (
            <div className="addfiles-div" style={{ marginTop: "8px" }}>
              <button
                type="button"
                className="button outline medium"
                style={{ width: "100%" }}
                onClick={() => {
                  if (props.selectedNode.metadataType === "list" || props.selectedNode.metadataType === "object") {
                    readMetaDatas(props.selectedNode);
                  } else {
                    readSerieMetaDatas(props.selectedNode);
                  }
                }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 11.75V12.75C10 12.8163 9.97366 12.8799 9.92678 12.9268C9.87989 12.9737 9.8163 13 9.75 13H6.25C6.1837 13 6.12011 12.9737 6.07322 12.9268C6.02634 12.8799 6 12.8163 6 12.75V11.75C6 11.6837 6.02634 11.6201 6.07322 11.5732C6.12011 11.5263 6.1837 11.5 6.25 11.5H7V7.5H6.25C6.1837 7.5 6.12011 7.47366 6.07322 7.42678C6.02634 7.37989 6 7.3163 6 7.25V6.25C6 6.1837 6.02634 6.12011 6.07322 6.07322C6.12011 6.02634 6.1837 6 6.25 6H8.75C8.8163 6 8.87989 6.02634 8.92678 6.07322C8.97366 6.12011 9 6.1837 9 6.25V11.5H9.75C9.8163 11.5 9.87989 11.5263 9.92678 11.5732C9.97366 11.6201 10 11.6837 10 11.75ZM9 4.75V3.25C9 3.1837 8.97366 3.12011 8.92678 3.07322C8.87989 3.02634 8.8163 3 8.75 3H7.25C7.1837 3 7.12011 3.02634 7.07322 3.07322C7.02634 3.12011 7 3.1837 7 3.25V4.75C7 4.8163 7.02634 4.87989 7.07322 4.92678C7.12011 4.97366 7.1837 5 7.25 5H8.75C8.8163 5 8.87989 4.97366 8.92678 4.92678C8.97366 4.87989 9 4.8163 9 4.75Z"
                    fill="var(--text-accent-secondary)"
                  />
                </svg>
                <span className="text">
                  {props.selectedNode.metadataType === "list" || props.selectedNode.metadataType === "object"
                    ? "Show metadata"
                    : "Show diagram"}
                </span>
              </button>
            </div>
          )}

          <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={foto.map((k) => {
              return { src: k };
            })}
            plugins={[Captions, Fullscreen, Video, Zoom, Download, Share]}
            captions={{
              hidden: false,
            }}
            styles={{
              root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .9)" },
              navigationNext: {
                "--yarl__color_button": "transparent",
                "--yarl__color_button_active": "transparent",
                "--yarl__color_button_hover": "transparent",
              },
              navigationPrev: {
                "--yarl__color_button": "transparent",
                "--yarl__color_button_active": "transparent",
                "--yarl__color_button_hover": "transparent",
              },
            }}
          />
        </div>
      )}
    </>
  );
}
